module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARFJREFUWEftlbFKxEAURe+1NF+RwibzCktt/QMb68XKVhC0EmwVtxKs19bOf9jCUjJ5hf6BYLeFWOTJQAqR1c1MggsyqTPvHM68EGLND9fMRxbIBXKBQQVUdatt22cATyKynfJJZ4FcIKqAqoqZTc1sIyycmW2S3DWzBcnHbglfi6I4LMvyvc9SRgmEgXVdH5G8/WH4B4A9EZn3gYd3ogU6iROSV0sgExGZ9YUnC4SD3vsLAOdfYJcichoDHyTQSUwBHAN4cM7tk2z/VCDAmqY5A3DjnFvEwgcXSAF+P7NyCb331yOAwr/ibtmcPgI2gsC9iBwkCajqzggCb1VVvSQJjAD/dcTKK8gCuUAu8O8LfAK1HWYhlNg6PgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/download3.png
// module id = JpW6
// module chunks = 1